import arrowRight from './assets/images/arrow-right.svg'
import c from './assets/sass/item.module.scss'

export const CategoryItem = ({ title, description, onClick }) => {
    return (
        <div className={c.component} onClick={onClick}>
            <div className={c.info}>
                <div className={c.title}>{title}</div>
                <div className={c.description}>{description}</div>
            </div>
            <div className={c.arrow}>
                <img src={arrowRight} alt="" />
            </div>
        </div>
    )
}
